/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dropdown } from "react-bootstrap";
import SntAddFilterColumnIcon from "@icons/SntAddFilterColumnIcon";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";

interface FilterActionsProps {
  column: any;
  isDisabbledAddFilter: boolean;
  restrictedFilters?: string[];
  filterVisibleKeys?: string[];
  onFilterClicked?: (
    action: string,
    columnKey: string,
    filterKeys: string[],
    cellValue: any[]
  ) => void;
}

export const FilterActions = ({
  column,
  isDisabbledAddFilter,
  restrictedFilters,
  filterVisibleKeys,
  onFilterClicked,
}: FilterActionsProps) => {
  const showFilterActions =
    !isDisabbledAddFilter &&
    column.filterKeys?.length > 0 &&
    (!restrictedFilters ||
      restrictedFilters.length === 0 ||
      !restrictedFilters?.includes(column.filterKeys[0])) &&
    !filterVisibleKeys?.includes(column.filterKeys[0]);

  if (!showFilterActions) return null;

  const handleAddFilter = () => {
    onFilterClicked?.("FILTER_FOR_VALUE", column.key, column.filterKeys, []);
  };

  return (
    <>
      <Dropdown.Item bsPrefix="dropdown-item" onClick={handleAddFilter}>
        <div className="d-flex">
          <div style={{ width: 20 }} className="d-flex align-items-center">
            <SntAddFilterColumnIcon />
          </div>
          <div>{translate(LanguageKey.add_column_to_filter_key)}</div>
        </div>
      </Dropdown.Item>
      <Dropdown.Divider className="table-group-menu-divider" />
    </>
  );
};
